import me from "models/me";
import { getStore } from "store";
import { fetchBrandDataflow } from "actions/utilities/dataflow-management-actions";

export default function (permission) {
    return function (_nextState, replace, callback) {
        if (!me.canViewBrand()) {
            replace({
                pathname: "/profile",
            });
            callback();
        } else if (me.hasPermission(permission)) {
            if (permission === "dataflow_self_service") {
                const store = getStore();
                store.dispatch(fetchBrandDataflow());
                store.subscribe(() => {
                    const onFetchBrandDataFlowValue$ = store.getState().dataflow?.brandFlow?.payload?.dataflow;
                    if (onFetchBrandDataFlowValue$ !== null) {
                        const merchantsList = onFetchBrandDataFlowValue$?.retailer_settings;
                        if (!merchantsList) {
                            replace({
                                pathname: "/404",
                            });
                        }
                        callback();
                    }
                });
            } else {
                callback();
            }
        } else {
            const addOnPermissions = ["can_create_whiteboards"]; // permissions that require brands to pay us monies

            if (addOnPermissions.includes(permission)) {
                replace({
                    pathname: "/403",
                });
            } else {
                replace({
                    pathname: "/404",
                });
            }
            callback();
        }
    };
}
